var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as _ from 'lodash';
import * as go from '../../../../libs/gojs/release/go';
import { VariableDefinition } from '@flexem/fc-gui';
import { NodeElement } from './base/node-element';
import { DiagramConsts } from '../diagram-consts';
import { DataType } from '../../core/variable/data-type';
var Part_Arc = 'Part_Arc';
var Part_Hand = 'Part_Hand';
var Part_BG = 'Part_BG';
var MeterElement = /** @class */ (function (_super) {
    __extends(MeterElement, _super);
    function MeterElement() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    MeterElement.prototype.compile = function (model, data, _svg) {
        model['version'] = 5;
        model['angle'] = data.angle;
        model['size'] = this.sizeService.parse(data.size);
        if (data.variableVersion) {
            var variable = _.find(DiagramConsts.compilerUsedVariables, function (v) { return v.variableName === data.variableName; });
            if (null != variable) {
                model['readVariable'] = { name: data.variableName, variableVersion: data.variableVersion };
            }
        }
        else {
            var variable = _.find(DiagramConsts.compilerUsedVariables, function (v) { return v.dataSourceCode === data.dataSourceCode
                && v.fBoxVariableName === data.variableName && (!data.variableGroupName || (v.fBoxGroupName === data.variableGroupName)); });
            if (null != variable) {
                model['readVariable'] = new VariableDefinition(variable.fBoxVariableName, variable.fBoxGroupName, variable.dataSourceCode);
            }
        }
        model['min'] = data.min;
        model['max'] = data.max;
        model['radius'] = data.width;
        if (this.hasDynamicSetting(data)) {
            model['dynamicSetting'] = data.dynamicSetting;
            model['location'] = go.Point.parse(data.loc);
            model['fixedPositionType'] = data.fixedPositionType;
        }
    };
    MeterElement.prototype.handleElementFinished = function (obj, svg) {
        if (!obj.part || obj.part.category !== DiagramConsts.elements.meterKey) {
            return;
        }
        var name = obj.name;
        if (name === Part_Arc) {
            $(svg).attr('data-id', 'arc');
        }
        else if (name === Part_Hand) {
            $(svg).attr('data-id', 'hand');
        }
        else if (name === Part_BG) {
            $(svg).attr('data-id', 'main');
        }
    };
    MeterElement.prototype.getPaletteTemplate = function () {
        var $ = go.GraphObject.make;
        return $(go.Node, 'Vertical', { width: 50, height: 90, locationSpot: go.Spot.Center }, $(go.Picture, { margin: 10, source: '/assets/common/images/configure/elements/meter.png' }), $(go.TextBlock, {
            alignment: go.Spot.Center,
            text: this.l(this.getCategoryKey()),
            editable: false
        }));
    };
    MeterElement.prototype.getDiagramTemplate = function () {
        var _this = this;
        var $ = go.GraphObject.make;
        return $(go.Node, 'Spot', {
            rotatable: true,
            resizable: true, resizeObjectName: Part_BG,
            locationObjectName: Part_BG,
            selectionObjectName: Part_BG,
            locationSpot: go.Spot.TopLeft,
            selectionAdornmentTemplate: $(go.Adornment, 'Spot', $(go.Panel, go.Panel.Auto, $(go.Shape, { fill: null, stroke: 'dodgerblue', strokeWidth: 1 }, new go.Binding('stroke', 'locked', function (locked) { return locked ? '#f65177' : 'dodgerblue'; })), $(go.Placeholder)))
        }, new go.Binding('locationSpot', '', function (data) {
            return _this.getFixedPositionType(data);
        }), new go.Binding('angle').makeTwoWay(), new go.Binding('movable', 'locked', function (locked) { return !locked; }), new go.Binding('resizable', 'locked', function (locked) { return !locked; }), new go.Binding('deletable', 'locked', function (locked) { return !locked; }), new go.Binding('rotatable', 'locked', function (locked) { return !locked; }), new go.Binding('location', 'loc', go.Point.parse).makeTwoWay(go.Point.stringify), new go.Binding('zOrder'), $(go.Shape, 'Square', {
            name: Part_BG, spot1: go.Spot.TopLeft, spot2: go.Spot.BottomRight,
            fill: 'transparent', stroke: 'transparent', strokeWidth: 2
        }, new go.Binding('desiredSize', 'size', go.Size.parse).makeTwoWay(go.Size.stringify)), this.makeScale(), $(go.Shape, {
            name: Part_Hand,
            fill: 'red',
            strokeWidth: 0,
            geometryString: 'F1 M-6 0 L0 -6 100 0 0 6z x M-100 0',
            angle: 150
        }, new go.Binding('geometryString', 'desiredSize', function (desiredSize) {
            var s = desiredSize.copy();
            if (!s.isReal()) {
                return;
            }
            var l = s.width / 2;
            return 'F1 M-6 0 L0 -6' + ' ' + l + ' ' + '0 0 6z x M-' + l + ' ' + '0';
        }).ofObject(Part_BG)));
    };
    MeterElement.prototype.getCategoryKey = function () {
        return DiagramConsts.elements.meterKey;
    };
    MeterElement.prototype.makeScale = function () {
        var $ = go.GraphObject.make;
        return $(go.Panel, 'Graduated', {
            stretch: go.GraphObject.None,
            alignmentFocus: go.Spot.Center,
            alignmentFocusName: Part_Arc
        }, new go.Binding('graduatedMax', 'max'), new go.Binding('graduatedMin', 'min'), new go.Binding('graduatedTickBase', 'min'), new go.Binding('graduatedTickUnit', '', function (data, node) {
            return (data.max - data.min) / data.masterDivisionNumber / data.subDivisionNumber;
        }), 
        // the main path of the graduated panel, an arc starting at 135 degrees and sweeping for 270 degrees
        $(go.Shape, {
            name: Part_Arc,
            geometryString: 'M-70.7 70.7 B135 270 0 0 100 100 M0 100',
            stroke: 'black',
            strokeWidth: 2
        }, new go.Binding('geometryString', 'desiredSize', function (desiredSize) {
            var s = desiredSize.copy();
            if (!s.isReal()) {
                return;
            }
            var r = s.width / 2;
            var k = Math.sqrt(r * r / 2);
            return 'M-' + k + ' ' + k + ' ' + 'B135 270 0 0 ' + r + ' ' + r + ' M0 ' + r;
        }).ofObject(Part_BG), 
        // TODO gui目前基于圆弧路径计算表针角度，所以即使不显示刻度也要把圆弧绘制出来。等gui算法调整好后，换visible直接移除掉会比较好。
        new go.Binding('stroke', '', function (model) {
            return model.showScale ? (model.calibrationColor || '#333333') : 'transparent';
        })), 
        // three differently sized tick marks
        $(go.Shape, { geometryString: 'M0 0 V8', stroke: 'black', strokeWidth: 1 }, new go.Binding('visible', 'showScale'), new go.Binding('stroke', 'calibrationColor')), $(go.Shape, { geometryString: 'M0 0 V16', stroke: 'black', strokeWidth: 2 }, new go.Binding('interval', 'subDivisionNumber'), new go.Binding('visible', 'showScale'), new go.Binding('stroke', 'calibrationColor')), $(go.TextBlock, {
            alignmentFocus: go.Spot.Center,
            font: '12px sans-serif', stroke: 'black',
            segmentOffset: new go.Point(0, 30)
        }, new go.Binding('graduatedFunction', '', function (data) {
            return function (value) {
                if (data.integerDigits) {
                    // eslint-disable-next-line eqeqeq
                    if (data.fractionDigits > 0) {
                        if (data.variableDataType && +data.variableDataType === DataType.Float) {
                            return value.toFixed(data.fractionDigits);
                        }
                        else {
                            return (value / Math.pow(10, data.fractionDigits)).toFixed(data.fractionDigits);
                        }
                    }
                    return value.toFixed(0);
                }
                return value;
            };
        }), new go.Binding('interval', 'subDivisionNumber'), new go.Binding('font', 'calibrationDigitFontStyle'), new go.Binding('stroke', 'calibrationDigitColor'), new go.Binding('isUnderline', 'calibrationDigitIsUnderline'), new go.Binding('visible', '', this.showCalibrationDigit)));
    };
    MeterElement.prototype.showCalibrationDigit = function (data) {
        if (data.showScale && !data.hasOwnProperty('showCalibrationDigit')) {
            return true;
        }
        return data.showScale && data.showCalibrationDigit;
    };
    return MeterElement;
}(NodeElement));
export { MeterElement };
